import { render, staticRenderFns } from "./NationalPatentOwnerList.vue?vue&type=template&id=5ae18a00&"
import script from "./NationalPatentOwnerList.vue?vue&type=script&lang=js&"
export * from "./NationalPatentOwnerList.vue?vue&type=script&lang=js&"
import style0 from "./NationalPatentOwnerList.vue?vue&type=style&index=0&id=5ae18a00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports